module.exports = __webpack_public_path__ + "../resources/img/bg_storage2_01.c7bbe576.png";